import React from 'react';
import { Retailer } from '../../Types/Retailer';
import RetailerStoreCard from './RetailerStoreCard';

interface RetailerListStoresProps {
  filteredRetailerList: Retailer[];
}

const RetailerListStores = ({
  filteredRetailerList,
}: RetailerListStoresProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      {filteredRetailerList.length > 0 &&
        filteredRetailerList.map((retailer) => (
          <RetailerStoreCard
            key={retailer.name + retailer.address1}
            retailer={retailer}
          />
        ))}
    </div>
  );
};

export default RetailerListStores;
